export default "__VITE_ASSET__30b32a73__"